import { SubmissionError } from 'redux-form'

export default function Submit (form) {
  let registerForm = new FormData()
  // add keys and values to form
  for (let key in form) {
    let value = form[key]

    registerForm.append(key, value)
  }

  return fetch('https://api.minetools.eu/uuid/' + form.minecraft)
    .then((response) => response.json())
    .then((resp) => {
      const uuid = resp.id
      if(!!uuid) {
        // if there is a uuid add to the data
        registerForm.append('mcuuid', uuid)
        // continue submit
        return fetch('/register/submit', {method: 'POST', body: registerForm})
          .then((response) => response.json())
          .then((json) => {
            if(json.error) {
              alert(json.error)
            } else {
              window.location.href = '/login/?registered'
            }
            return null
          })
      } else {
        // otherwise invalid name
        throw new SubmissionError({
          minecraft: 'Invalid Minecraft name!'
        })
      }
    })
}


// WEBPACK FOOTER //
// ./src/submit.js